module.exports = __webpack_public_path__ + "static/icons/icon-map--spain-5ea1a16001440c8d681bd578225c1b2d.svg";